// DiagramElement discriminated union. ResultsSchedule was the first variant; the
// text/shape annotation variants (spec §7) are the Connect-native targets Desktop
// `.pipe` text / geometric_shape annotations map into (F2). Future variants (dxf,
// screenshots) append here.

import { z } from 'zod';
import { ResultsScheduleSchema } from './results-schedule';
import { TextElementSchema } from './text';
import { ShapeElementSchema } from './shape';
import { ImageElementSchema } from './image';

export const DiagramElementSchema = z.discriminatedUnion('kind', [
  ResultsScheduleSchema,
  TextElementSchema,
  ShapeElementSchema,
  ImageElementSchema,
]);

export type DiagramElement = z.infer<typeof DiagramElementSchema>;

// Re-export variant schemas and types for convenience.
export { ResultsScheduleSchema, FilterSchema } from './results-schedule';
export type { ResultsSchedule, Filter, FilterOperator, SortState, SortDirection } from './results-schedule';
export { TextElementSchema } from './text';
export type { TextElement } from './text';
export { ShapeElementSchema, ShapeKindSchema } from './shape';
export type { ShapeElement, ShapeKind } from './shape';
export { ImageElementSchema, ImageRefSchema } from './image';
export type { ImageElement, ImageRef } from './image';
